import CloseIcon from '@mui/icons-material/Close';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
  AppBar,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  IconButton,
  Modal,
  Skeleton,
  Slide,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { useSnackbar } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { fetchPEDataReport } from "../../../api's/LlmMapperApi";
import { WorkflowContext } from '../../../contexts/WorkflowProvider';
import LoadingIcon from '../../../reusable-component/LoadingIcon';
import generateAlias from '../../../utils/generateAlias';
import GraphChart from '../llm-mapper-component/GraphChart';

const responseData = {
  formulaWithGraphs: [
    {
      formulaName: 'MRR',
      graph: {
        title: {
          text: 'Basic Graph',
        },
        series: [
          {
            data: [
              {
                x: 300,
                y: 300,
                name: 'ARR',
                itemStyle: {
                  color: 'red',
                },
              },
              {
                x: 500,
                y: 300,
                name: 'MRR',
              },
              {
                x: 800,
                y: 300,
                name: 'Date',
              },
              {
                x: 650,
                y: 200,
                name: 'Revenue',
              },
              {
                x: 650,
                y: 400,
                name: 'Users',
                itemStyle: {
                  color: 'red',
                },
              },
            ],
            roam: true,
            type: 'graph',
            label: {
              show: true,
            },
            links: [
              {
                source: 'MRR',
                target: 'ARR',
              },
              {
                source: 'Revenue',
                target: 'MRR',
                lineStyle: {
                  curveness: -0.2,
                },
              },
              {
                source: 'Users',
                target: 'MRR',
                lineStyle: {
                  curveness: 0.2,
                },
              },
              {
                source: 'Date',
                target: 'Revenue',
                lineStyle: {
                  curveness: -0.2,
                },
              },
              {
                source: 'Date',
                target: 'Users',
                lineStyle: {
                  curveness: 0.2,
                },
              },
            ],
            layout: 'none',
            edgeLabel: {
              fontSize: 20,
            },
            lineStyle: {
              color: 'source',
              width: 2,
              opacity: 0.9,
            },
            edgeSymbol: ['circle', 'arrow'],
            symbolSize: 100,
            edgeSymbolSize: [4, 10],
          },
        ],
        tooltip: {},
        animationEasingUpdate: 'quinticInOut',
        animationDurationUpdate: 1500,
      },
    },
    {
      formulaName: 'MRR',
      graph: {
        title: {
          text: 'Basic Graph',
        },
        series: [
          {
            data: [
              {
                x: 300,
                y: 300,
                name: 'ARR',
                itemStyle: {
                  color: 'red',
                },
              },
              {
                x: 500,
                y: 300,
                name: 'MRR',
              },
              {
                x: 800,
                y: 300,
                name: 'Date',
              },
              {
                x: 650,
                y: 200,
                name: 'Revenue',
              },
              {
                x: 650,
                y: 400,
                name: 'Users',
                itemStyle: {
                  color: 'red',
                },
              },
            ],
            roam: true,
            type: 'graph',
            label: {
              show: true,
            },
            links: [
              {
                source: 'MRR',
                target: 'ARR',
              },
              {
                source: 'Revenue',
                target: 'MRR',
                lineStyle: {
                  curveness: -0.2,
                },
              },
              {
                source: 'Users',
                target: 'MRR',
                lineStyle: {
                  curveness: 0.2,
                },
              },
              {
                source: 'Date',
                target: 'Revenue',
                lineStyle: {
                  curveness: -0.2,
                },
              },
              {
                source: 'Date',
                target: 'Users',
                lineStyle: {
                  curveness: 0.2,
                },
              },
            ],
            layout: 'none',
            edgeLabel: {
              fontSize: 20,
            },
            lineStyle: {
              color: 'source',
              width: 2,
              opacity: 0.9,
            },
            edgeSymbol: ['circle', 'arrow'],
            symbolSize: 100,
            edgeSymbolSize: [4, 10],
          },
        ],
        tooltip: {},
        animationEasingUpdate: 'quinticInOut',
        animationDurationUpdate: 1500,
      },
    },
  ],
  columnWithAggregatePercentages: [
    {
      columnName: 'OpportunityName',
      percentage: 100.0,
    },
    {
      columnName: 'ContactID',
      percentage: 100.0,
    },
    {
      columnName: 'Product_Service',
      percentage: 100.0,
    },
    {
      columnName: 'SalesValue',
      percentage: 50.0,
    },
    {
      columnName: 'Quantity_Seats',
      percentage: 100.0,
    },
    {
      columnName: 'CreatedDate',
      percentage: 100.0,
    },
    {
      columnName: 'Lastupdate',
      percentage: 100.0,
    },
    {
      columnName: 'LeadSource',
      percentage: 100.0,
    },
    {
      columnName: 'ContactName',
      percentage: 66.67,
    },
    {
      columnName: 'ContactType',
      percentage: 100.0,
    },
    {
      columnName: 'ContactOwner',
      percentage: 100.0,
    },
    {
      columnName: 'LastContactDate',
      percentage: 100.0,
    },
    {
      columnName: 'Email',
      percentage: 100.0,
    },
    {
      columnName: 'OrganizationName',
      percentage: 100.0,
    },
    {
      columnName: 'Region',
      percentage: 100.0,
    },
    {
      columnName: 'Location',
      percentage: 100.0,
    },
    {
      columnName: 'Website',
      percentage: 0.0,
    },
    {
      columnName: 'City',
      percentage: 100.0,
    },
    {
      columnName: 'PotentialRevenue',
      percentage: 97.33,
    },
    {
      columnName: 'PhoneNumber',
      percentage: 38.0,
    },
    {
      columnName: 'LinkedinURL',
      percentage: 50.0,
    },
    {
      columnName: 'OrganisationID',
      percentage: 100.0,
    },
    {
      columnName: 'OpportunityStatus',
      percentage: 100.0,
    },
    {
      columnName: 'OpportunityStage',
      percentage: 100.0,
    },
    {
      columnName: 'Margin',
      percentage: 66.67,
    },
    {
      columnName: 'Discount',
      percentage: 50.0,
    },
    {
      columnName: 'LeadStatus',
      percentage: 100.0,
    },
    {
      columnName: 'LifecycleStage',
      percentage: 100.0,
    },
    {
      columnName: 'RoleinDecisionMaking',
      percentage: 100.0,
    },
  ],
};

const styleLoading = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const NodeModalPEDataReport = ({ nodeId, nodeName, handleClose, open, nodes, edges, changeNodeName, setNodes }) => {
  const { enqueueSnackbar } = useSnackbar();
  const INITIALSTATE = {
    action: '',
    persist: false,
    df: '',
    alias: generateAlias(nodeName, nodeId),
    persist_type: '',
    db_name: '',
    statement: '',
    distinct_rows: false,
    mappings: [],
    sample_view: true,
  };
  const { workflow } = useContext(WorkflowContext);
  const [formField, setFormField] = useState(INITIALSTATE);
  const [disableForm, setDisableForm] = useState(false);
  const [headerName, setHeaderName] = useState([]);
  const [fetchedHeader, setFetchedHeader] = useState([]);
  const [tempHeader, setTempHeader] = useState([]);

  const [refreshModalOpen, setRefreshModalOpen] = useState(false);
  const handleRefreshModalOpen = () => setRefreshModalOpen(true);
  const handleRefreshModalClose = () => setRefreshModalOpen(false);
  const [mapping, setMapping] = useState([]);
  const [loader, setLoader] = useState(false);
  const [dataReport, setDataReport] = useState({});

  const store = JSON.parse(sessionStorage.getItem('allNodes'));

  const getLocalData = () => {
    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;
      let prev_formField;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_nodeName = node.step_name;
            prev_formField = node.formField;
          }
        });
      });
      setFormField({ ...formField, df: prev_alias });
      setMapping(prev_formField?.mappings);

      const newArr = [];
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const newHeader = uniqueArray.map((el) => {
        return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
      });

      //
      const head = [];
      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      setFetchedHeader(newHeader);

      store.forEach((node) => {
        if (node.nodeId === nodeId) {
          setFormField(node.formField);
          setHeaderName(node.headerName);
          setTempHeader(node.headerName);

          if (node.disabled) {
            setDisableForm(node.disabled);
          }
        }
      });
    }
  };

  // Executes at start
  useEffect(() => {
    setFormField(INITIALSTATE);
    setDisableForm(false);
    setFetchedHeader([]);
    setHeaderName([]);
    getLocalData();
  }, [nodeId]);

  useEffect(() => {
    if (mapping && mapping?.length > 0) {
      getPEDataReport();
    }
  }, [mapping]);

  const refreshAllState = () => {
    handleRefreshModalOpen();

    let updateNodes = JSON.parse(sessionStorage.getItem('updatedNodes')) || [];

    let count = 0;

    setNodes((nds) =>
      nds.map((node) => {
        if (count <= updateNodes.length && node.id === updateNodes[count]) {
          node.position.x -= 0.1;
          count++;
        }

        return node;
      })
    );

    updateNodes = updateNodes.filter((el) => el !== nodeId);

    sessionStorage.setItem('updatedNodes', JSON.stringify(updateNodes));

    const findSrcNodeId = [];
    edges.forEach((el) => {
      if (el.target === nodeId) {
        findSrcNodeId.push(el.source);
      }
    });

    if (findSrcNodeId.length === 0) {
      setFormField(INITIALSTATE);
      setDisableForm(false);
      setFetchedHeader([]);
      setHeaderName([]);

      enqueueSnackbar('No source node is connected !!!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
      handleRefreshModalClose();
      return;
    }

    let nodesExist = false;

    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        nodesExist = true;
      }
    });

    if (store && findSrcNodeId) {
      let header = [];
      let prev_alias;
      let prev_nodeName;

      findSrcNodeId.forEach((item, i) => {
        store.forEach((node) => {
          if (node.nodeId === item) {
            header.push(...node.headerName);
            prev_nodeName = node.step_name;
          }
        });
      });

      setFormField({ ...formField, df: prev_alias });

      const newArr = [];

      if (prev_nodeName === 'Join') {
        header.forEach((el) => {
          const exist = el.header.split('.').length;

          if (exist === 2) {
            const head = el.header.split('.')[1];
            newArr.push({ ...el, header: el.alias ? el.alias : head });
          }
        });
      }
      if (newArr.length > 0) {
        header = newArr;
      }

      const uniqueHeader = [];

      const uniqueArray = header.filter((element) => {
        const isDuplicate = uniqueHeader.includes(element.header);

        if (!isDuplicate) {
          uniqueHeader.push(element.header);
          return true;
        }

        return false;
      });

      const newHeader = uniqueArray.map((el) => {
        return { ...el, header: el.alias ? el.alias : el.header, alias: el.alias ? '' : el.alias };
      });

      //
      const head = [];
      newHeader.forEach((el) => {
        head.push({ label: el.header });
      });

      if (nodesExist) {
        store.forEach((node) => {
          if (node.nodeId === nodeId) {
            setFormField(node.formField);
            setHeaderName(node.headerName);

            const nonExistingHeader = [];
            node.fetchedHeader.forEach((item) => {
              const index = newHeader.findIndex((x) => x.header === item.header);

              if (index !== -1) {
                nonExistingHeader.push(item);
              }
            });

            newHeader.forEach((el) => {
              const index = nonExistingHeader.findIndex((x) => x.header === el.header);

              if (index === -1) {
                nonExistingHeader.push({
                  ...el,
                  header: el.alias ? el.alias : el.header,
                  alias: el.alias ? '' : el.alias,
                });
              }
            });

            setFetchedHeader(nonExistingHeader);
          }
        });
      } else {
        setFetchedHeader(newHeader);
      }
    }

    enqueueSnackbar('Data Refreshed!!!', {
      variant: 'Success',
      autoHideDuration: 3000,
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
    });
    handleRefreshModalClose();
  };

  let name, value;
  const handleInputChange = (e) => {
    name = e.target.name;
    value = e.target.value;

    setFormField({
      ...formField,
      [name]: value,
    });
  };

  const handleResetForm = () => {
    setFormField(INITIALSTATE);
  };

  const compareTwoArrayOfObjects = (first_array_of_objects, second_array_of_objects) => {
    return (
      first_array_of_objects.length === second_array_of_objects.length &&
      first_array_of_objects.every((element_1) =>
        second_array_of_objects.some(
          (element_2) =>
            element_1.header === element_2.header &&
            element_1.tableAlias === element_2.tableAlias &&
            element_1.alias === element_2.alias &&
            element_1.checked === element_2.checked
        )
      )
    );
  };

  const handleFormsubmit = async (e) => {
    e.preventDefault();

    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes') || '[]');

    if (getAllNodes.length > 0) {
      const newFormData = getAllNodes.filter((el) => el.nodeId !== nodeId);
      sessionStorage.setItem('allNodes', JSON.stringify(newFormData));
    }

    let y_axis;

    nodes.forEach((el) => {
      if (nodeId === el.id) {
        y_axis = parseInt(el.position.x, 10);
        el.data.label = formField.alias;
      }
    });

    const newHeaderName = [];

    fetchedHeader.forEach((item) => {
      newHeaderName.push({ ...item, tableAlias: formField.alias });
    });

    let equalArray;
    if (tempHeader.length > 0) {
      equalArray = compareTwoArrayOfObjects(tempHeader, newHeaderName);
    }

    const connectedNodes = [];
    if (!equalArray && tempHeader.length > 0) {
      edges.forEach((el) => {
        if (el.source === nodeId) connectedNodes.push(el.target);
      });

      let count = 0;

      setNodes((nds) =>
        nds.map((node) => {
          if (count <= connectedNodes.length && node.id === connectedNodes[count]) {
            node.position.x += 0.1;
            count++;
          }

          return node;
        })
      );
    }

    sessionStorage.setItem('updatedNodes', JSON.stringify(connectedNodes));

    setHeaderName(newHeaderName);

    const sendFormData = {
      nodeId,
      nodeName,
      formField,
      disabled: true,
      step_name: nodeName,
      y_axis,
      headerName: newHeaderName,
      fetchedHeader,
    };

    changeNodeName(nodes);

    setDisableForm(true);

    sessionStorage.setItem('node', JSON.stringify(nodes));
    sessionStorage.setItem('edges', JSON.stringify(edges));

    const fetchNodesData = JSON.parse(sessionStorage.getItem('allNodes') || '[]');
    fetchNodesData.push(sendFormData);
    sessionStorage.setItem('allNodes', JSON.stringify(fetchNodesData));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node') || '[]');
    getElements.push(nodeId);
    sessionStorage.setItem('saved_node', JSON.stringify(getElements));
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setDisableForm(false);
    store.forEach((node) => {
      if (node.nodeId === nodeId) {
        setTempHeader(headerName);
      }
    });
    const getAllNodes = JSON.parse(sessionStorage.getItem('allNodes'));

    getAllNodes.forEach((el) => {
      if (el.nodeId === nodeId) {
        el['disabled'] = false;
      }
    });

    sessionStorage.setItem('allNodes', JSON.stringify(getAllNodes));

    const getElements = JSON.parse(sessionStorage.getItem('saved_node'));

    const newSavedElement = getElements.filter((el) => el !== nodeId);

    sessionStorage.setItem('saved_node', JSON.stringify(newSavedElement));
  };

  const getPEDataReport = async () => {
    setLoader(true);
    try {
      const payload = {
        formulaList: mapping?.map((item) => item.metric),
        insightsPath: `${workflow.engagement.client.client_name}/${workflow.engagement.engagement_name}/${workflow.workflow_name}/output/insights/llm_insights.json`,
      };
      const response = await fetchPEDataReport(payload);
      if (response.status === 200) {
        setDataReport(response.data);
      }
    } catch (error) {
      setLoader(false);
      enqueueSnackbar('PE Report not found!', {
        variant: 'error',
        autoHideDuration: 3000,
        anchorOrigin: { vertical: 'top', horizontal: 'right' },
      });
    }
    setLoader(false);
  };

  const SkeletonLoader = () => {
    return (
      <>
        <Skeleton variant="text" sx={{ fontSize: '2rem', width: '130px', marginBottom: '50px' }} />
        <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '100px' }}>
          <Skeleton variant="circular" width={125} height={125} />
          <Skeleton variant="text" sx={{ fontSize: '1rem', width: '120px' }} />
          <Skeleton variant="circular" width={125} height={125} />
          <Skeleton variant="text" sx={{ fontSize: '1rem', width: '120px' }} />
          <Skeleton variant="circular" width={125} height={125} />
          <Skeleton variant="text" sx={{ fontSize: '1rem', width: '120px' }} />
          <Skeleton variant="circular" width={125} height={125} />
        </Box>
      </>
    );
  };

  return (
    <div>
      <Dialog
        fullScreen
        open={open}
        // onClose={handleClose}
        TransitionComponent={Transition}
        style={{ width: '70%', marginLeft: '30%' }}
      >
        <form autoComplete="off" onSubmit={handleFormsubmit}>
          <AppBar sx={{ position: 'relative', backgroundColor: '#fff' }}>
            <Toolbar>
              <IconButton edge="start" onClick={handleClose} aria-label="close" sx={{ color: '#00043C' }}>
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1, color: '#00043C' }} variant="h6" component="div">
                {nodeName}
              </Typography>
              <Tooltip title="Refresh Schema" placement="left">
                <IconButton
                  disabled={disableForm}
                  edge="start"
                  onClick={refreshAllState}
                  aria-label="close"
                  sx={{ color: '#00043C' }}
                >
                  <RotateLeftIcon />
                </IconButton>
              </Tooltip>
              <ButtonGroup variant="contained" aria-label="outlined primary button group">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={handleResetForm}
                  disabled={disableForm}
                  className="outlined-button-color"
                >
                  Clear
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={!disableForm}
                  className="outlined-button-color"
                  onClick={handleEdit}
                >
                  Edit
                </Button>
                <Button type="submit" size="small" variant="contained" disabled={disableForm} className="button-color">
                  Submit
                </Button>
              </ButtonGroup>
            </Toolbar>
          </AppBar>
          <div style={{ margin: '20px' }}>
            {loader && (
              <>
                <SkeletonLoader /> <SkeletonLoader />
              </>
            )}

            {dataReport?.formulaWithGraphs?.map((item, index) => (
              <GraphChart
                data={item.graph}
                mapping={mapping?.[index]}
                columnData={dataReport.columnWithAggregatePercentages}
              />
            ))}
          </div>
        </form>
      </Dialog>
      <Modal open={refreshModalOpen} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={styleLoading}>
          <LoadingIcon />
        </Box>
      </Modal>
    </div>
  );
};

export default NodeModalPEDataReport;
